(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casoman-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
  function initialize(root) {
    root.querySelectorAll('[data-casoman-buy-now]').forEach(function (button) {
      if (button.dataset.initialized) return;
      var form = button.closest('form');
      if (!form) return;
      var variantData = form.querySelector('[data-casoman-buy-now-variants]');
      if (!variantData) return;
      var variants = JSON.parse(variantData.textContent);
      var addButton = form.querySelector('[data-add-to-cart]');
      var busy = false;
      button.dataset.initialized = 'true';
      function selectedVariant() {
        var input = form.elements.namedItem('id');
        return variants.find(function (variant) {
          return input && String(variant.id) === String(input.value);
        });
      }
      function synchronize() {
        var variant = selectedVariant();
        button.disabled = busy || !variant || !variant.available;
      }
      function showError(message) {
        var wrapper = form.querySelector('[data-error-message-wrapper]');
        var text = form.querySelector('[data-error-message]');
        if (wrapper && text) {
          text.textContent = message;
          wrapper.classList.remove('product-form__error-message-wrapper--hidden');
          wrapper.hidden = false;
        }
      }
      form.addEventListener('change', function () {
        requestAnimationFrame(synchronize);
      });
      if (addButton) {
        new MutationObserver(synchronize).observe(addButton, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'disabled', 'class']
        });
      }
      synchronize();
      button.addEventListener('click', async function (event) {
        event.preventDefault();
        if (busy) return;
        synchronize();
        if (button.disabled) return;
        var quantityInput = form.elements.namedItem('quantity');
        var quantity = quantityInput ? Number(quantityInput.value) : 1;
        if (!Number.isInteger(quantity) || quantity < 1) {
          if (quantityInput) {
            quantityInput.setCustomValidity(button.dataset.errorLabel);
            quantityInput.reportValidity();
            quantityInput.addEventListener('input', function () {
              quantityInput.setCustomValidity('');
            }, { once: true });
          }
          showError(button.dataset.errorLabel);
          return;
        }
        if (!form.reportValidity()) return;
        var terms = form.querySelector('.terms_conditions_wrapper input[type="checkbox"]');
        if (terms && !terms.checked) {
          terms.focus();
          return;
        }
        if (window.casomanTrackConversion) window.casomanTrackConversion('buy_now_click');
        var data = new FormData(form);
        data.set('quantity', String(quantity));
        var previousAddDisabled = addButton ? addButton.disabled : false;
        var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.loadingLabel;
        form.classList.add('casoman-buy-now-busy');
        if (addButton) addButton.disabled = true;
        var wrapper = form.querySelector('[data-error-message-wrapper]');
        if (wrapper) wrapper.classList.add('product-form__error-message-wrapper--hidden');
        try {
          var response = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data
          });
          var result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(result.description || result.message || button.dataset.errorLabel);
          }
          window.location.assign(rootUrl + 'checkout');
        } catch (error) {
          showError(error.message || button.dataset.errorLabel);
          busy = false;
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.label;
          form.classList.remove('casoman-buy-now-busy');
          if (addButton) addButton.disabled = previousAddDisabled;
          synchronize();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casoman-cart-ux"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const shortcut=event.target.closest('[data-casoman-cart-checkout]');
 if(!shortcut)return;
 const form=shortcut.closest('form');
 const primary=form&&form.querySelector('[name="checkout"]');
 if(!primary)return;
 const terms=form.querySelector('#terms-conditions-cart');
 if(terms&&!terms.checked){terms.scrollIntoView({block:'center',behavior:'smooth'});terms.focus();return;}
 primary.click();
});

(function(){
 function bind(){
  document.querySelectorAll('.casoman-cart-ux form.cart').forEach(function(form){
   if(form.dataset.casomanAutoUpdate)return;
   form.dataset.casomanAutoUpdate='true';
   let timer,submitting=false;
   function update(){
    if(submitting)return;
    const inputs=Array.from(form.querySelectorAll('.cart__qty-input'));
    const invalid=inputs.find(function(input){return input.value===''||!input.checkValidity();});
    if(invalid){invalid.reportValidity();invalid.focus();return;}
    const changed=inputs.some(function(input){return input.value!==input.defaultValue;});if(!changed)return;
    const button=form.querySelector('[name="update"]');if(!button)return;
    clearTimeout(timer);form.requestSubmit(button);
   }
   function schedule(){clearTimeout(timer);timer=setTimeout(update,450);}
   form.addEventListener('input',function(e){if(e.target.matches('.cart__qty-input'))schedule();});
   form.addEventListener('change',function(e){if(e.target.matches('.cart__qty-input'))schedule();});
   form.addEventListener('keydown',function(e){if(e.key==='Enter'&&e.target.matches('.cart__qty-input')){e.preventDefault();update();}});
   form.addEventListener('click',function(e){
    const button=e.target.closest('[data-plus-qtt],[data-minus-qtt]');if(!button)return;
    const input=button.closest('.qty-group')?.querySelector('.cart__qty-input');if(!input)return;
    e.preventDefault();e.stopImmediatePropagation();
    const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<0){input.reportValidity();return;}
    input.value=String(Math.max(0,quantity+(button.hasAttribute('data-plus-qtt')?1:-1)));schedule();
   },true);
   form.addEventListener('submit',function(){clearTimeout(timer);submitting=true;});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
 document.addEventListener('shopify:section:load',bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casoman-conversion-tracking"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.casomanTrackConversion) return;
  var allowedEvents = ['exit_popup_view', 'exit_popup_close', 'exit_checkout_click', 'add_popup_checkout_click', 'buy_now_click'];
  window.casomanTrackConversion = function (name, details) {
    try {
      if (allowedEvents.indexOf(name) === -1 || (window.Shopify && window.Shopify.designMode)) return;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      if (!analytics || typeof analytics.publish !== 'function') return;
      var payload = { tracking_version: 'casoman_conversion_v1' };
      if (details && ['close_button', 'continue_shopping', 'escape', 'other'].indexOf(details.close_reason) !== -1) {
        payload.close_reason = details.close_reason;
      }
      var result = analytics.publish('casoman:' + name, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_) {}
  };
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-casoman-popup-checkout]') : null;
    if (link) window.casomanTrackConversion('add_popup_checkout_click');
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casoman-mobile-services"] && !Shopify.designMode) return;
  try {
    (function(){
 const states=new WeakMap(),mobile=window.matchMedia('(max-width:767px)');
 function arrange(){
  document.querySelectorAll('.product_template').forEach(function(root){
   const slot=root.querySelector('[data-casoman-services-destination]');
   const source=root.querySelector('.product_services.casoman-mobile-services');
   if(!slot||!source)return;
   let state=states.get(root);
   if(mobile.matches&&!state){
    const list=source.querySelector('ul.services');if(!list)return;
    const marker=document.createElement('span');marker.hidden=true;
    list.parentNode.insertBefore(marker,list);slot.appendChild(list);
    if(!source.querySelector('.contact'))source.classList.add('casoman-services-empty');
    states.set(root,{list:list,marker:marker});
   }else if(!mobile.matches&&state){
    state.marker.parentNode.insertBefore(state.list,state.marker);
    state.marker.remove();source.classList.remove('casoman-services-empty');states.delete(root);
   }
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arrange);else arrange();
 mobile.addEventListener('change',arrange);
 document.addEventListener('shopify:section:load',arrange);
})();
  } catch(e) { console.error(e); }
})();

})();
